import { RedemptionPendingStatusEnum } from 'common/enums/RedemptionStatusEnum'
import useBoundState from 'store'

export const useShouldDisplayRedemptionTab = () => {
  const completedTickets = useBoundState((state) => state.tickets.completed)

  if (!completedTickets || completedTickets.length === 0) {
    return false
  }

  const filteredTickets = completedTickets.filter(
    (ticket) =>
      ticket.redemptionStatus !== RedemptionPendingStatusEnum.PENDING &&
      ticket.redemptionStatus !== RedemptionPendingStatusEnum.PENDING_PROCESSING,
  )

  return filteredTickets.length > 0
}
